import { withAPIAccount } from '../../lib/http/api';
import { APIError, parsedResponse } from '../../lib/http/http';
import { AccountType } from '../../model';
import { API_PREFIX } from '../config';
import { messageError } from '../../components/message';
import {
  IDownloadCenterConfig,
  IDownloadCenterObject,
  IDownloadCenterDownload,
  IVersionItem,
  IDownloadNews,
} from '../../model/api-modules/download-center';

// 配置项
export const getDownloadCenterConfig = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/download-center/config`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IDownloadCenterConfig>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        messageError(err?.apiError?.message);
      }
      return null;
    }
  });

// 下载物版本列表
export const getDownloadCenterVersion = (objectId: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/download-center/object/${objectId}/version`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IVersionItem[]>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });

// 下载物列表
export const getDownloadCenterObject = () =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/download-center/object`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IDownloadCenterObject[]>(
        response,
        'data'
      );
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });

// 创建下载任务
export const getDownloadCenterDownload = (body: IDownloadCenterDownload) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/download-center/download`;
      const response = await api.commonRequest('POST', url, body);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (err) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });

// 获取任务状态
export const getDownloadCenterDownloadStatus = (key: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/download-center/download/${key}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });

// 取消下载任务
export const cancelDownloadCenterDownload = (key: string) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/download-center/download/${key}`;
      const response = await api.commonRequest('PATCH', url);
      const res = await parsedResponse<any>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });

// 获取消息详情
export const getDownloadCenterNewsDetail = (id: number) =>
  withAPIAccount(AccountType.auto, async (api) => {
    try {
      const url = `${API_PREFIX}/news/${id}`;
      const response = await api.commonRequest('GET', url);
      const res = await parsedResponse<IDownloadNews>(response, 'data');
      return res;
    } catch (err: any) {
      if (err instanceof APIError) {
        console.log('error', err?.apiError?.message);
      }
      return null;
    }
  });
